import React from 'react';
import PropTypes from 'prop-types';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';


const ReviewItem = ({ text, name, next }) => {
  return (
    <ReactCSSTransitionGroup
      transitionName={next ? 'review-item-right' : 'review-item-left'}
      transitionEnterTimeout={500}
      transitionLeaveTimeout={500}
    >
      <div key={name} className="text">
        {text}
        <div className="title mt-3">
          {name}
        </div>
      </div>
    </ReactCSSTransitionGroup>
  );
};


ReviewItem.propTypes = {
  text: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  next: PropTypes.bool.isRequired
};


export default ReviewItem;



// WEBPACK FOOTER //
// ./src/components/Home/Reviews/ReviewItem.js